const IceBoxShelfList = () => import('Views/iceBoxShelf/iceBoxShelf-list');
const IceBoxShelfAddEdit = () => import('Views/iceBoxShelf/iceBoxShelf-addEdit');
const IceBoxShelfDetail = () => import('Views/iceBoxShelf/iceBoxShelf-detail');

export default[
  { path: '/iceBoxShelf-list', component: IceBoxShelfList },
  { path: '/iceBoxShelf-add', component: IceBoxShelfAddEdit },
  { path: '/iceBoxShelf-edit/:id', component: IceBoxShelfAddEdit },
  { path: '/iceBoxShelf-detail/:id', component: IceBoxShelfDetail },
];



// WEBPACK FOOTER //
// ./src/router/iceBoxShelf.js